import React from "react";
import DashboardPart from "./DashbordPart";
import Storage from "../../Images/dashboard_storage.png";

const DashboardStorage = ({ dashboardTotalInfo, isLoading }) => {
  return (
    <DashboardPart
      DashboardHeading="Storage"
      DashboardValue={dashboardTotalInfo?.total_vol_approved}
      Icon={Storage}
      style={{ background: "linear-gradient(to right, #750504, #FACC15)" }}
      isLoading={isLoading}
    />
  );
};

export default DashboardStorage;
